import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import PropTypes from 'prop-types';

import Slider from 'react-slick';

import styled from '@emotion/styled';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import { ReactComponent as ArrowLeftIconB } from 'assets/images/left-arrow.svg';
import { ReactComponent as ArrowRightIconB } from 'assets/images/right-arrow.svg';

const SliderContainer = styled.div`
  --side-padding: 8vw;

  padding: 0 var(--side-padding);

  width: 100%;
  max-width: calc(1280px + 2 * var(--side-padding));
  margin: auto;
`;

const DesktopSlider = styled(Slider)`
  width: 100%;
  margin: 0 auto;
  padding-bottom: 38px;
  margin-bottom: 140px;

  .slick-dots li {
    margin: 0px;
  }
  .slick-prev,
  .slick-next {
    width: 65px;
    height: 28px;
  }
  .slick-prev {
    left: calc(-0.75 * var(--side-padding));
  }
  .slick-next {
    right: calc(-0.75 * var(--side-padding));
  }
  .slick-prev:before,
  .slick-next:before {
    display: none;
  }
`;

const CustomSliderArrowWrapper = styled.button`
  border: none;
  background: none;
`;

const CustomSliderArrow = ({ className, style, onClick, direction }) => {
  return (
    <CustomSliderArrowWrapper className={className} onClick={onClick} style={style} type="button">
      {direction === 'left' ? <ArrowLeftIconB /> : <ArrowRightIconB />}
    </CustomSliderArrowWrapper>
  );
};

CustomSliderArrow.defaultProps = {
  className: '',
  style: {},
  onClick: () => {},
};
CustomSliderArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  direction: PropTypes.string.isRequired,
};

const DesktopCustomSlider = ({ cards }) => {
  return (
    <SliderContainer>
      <DesktopSlider
        dots
        infinite
        nextArrow={<CustomSliderArrow direction="right" />}
        prevArrow={<CustomSliderArrow direction="left" />}
        slidesToScroll={1}
        slidesToShow={3}
      >
        {cards}
      </DesktopSlider>
    </SliderContainer>
  );
};

DesktopCustomSlider.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      capacity: PropTypes.string,
      priceWithSubscription: PropTypes.number,
      productSquaredPicture: srcOrNextImageProp,
      productSquaredPictureHover: srcOrNextImageProp,
      productPageUrl: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default DesktopCustomSlider;
